<div (click)="dimmClick()" class="dialog-dimm" [ngClass]="{'fade':visible, 'show':visible}" [ngStyle]="{'display':(visible)?'block':'none'}">
    <div class="dialog" (click)="preventPropagation($event)">
        <ng-content></ng-content>
    </div>
</div>

